module.exports = __webpack_public_path__ + "static/media/about-seneca.b28cc01b.jpg";